import React, {useState, useEffect} from "react";

import { DatePicker, Button, Table, message, Modal, Space, Upload, Typography } from "antd";
import { UploadOutlined, CheckCircleTwoTone, CloseCircleTwoTone, BarChartOutlined  } from '@ant-design/icons';
import styled from "styled-components";
import moment from 'moment';

import { postData,getData } from '../../config/api-connect';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../config/api-connect';

function PhonePeSummary() {
  const { MonthPicker } = DatePicker;
  const [selectedMonth, setSelectedMonth] = useState(moment());
  const [isUploadOpen, setIsUploadOpen] = useState(false)
  const [fileList, setFileList] = useState([])
  const [uploadLoading, setUploadLoading] = useState(false)
  const [summaryLoader, setSummaryLoader] = useState(false)
  const [summaryData, setSummaryData] = useState([])
  const [summaryTotals, setSummaryTotals] = useState({
                                                      total: 0,
                                                      processed: 0,
                                                      unprocessed: 0,
                                                    });

  useEffect(() => {
    get_phonepe_summary()
  },[selectedMonth])

  useEffect(() => {
    if (summaryData) {
      const totalTotal = summaryData.reduce((s, r) => s + r.total_amount, 0);
      const totalProcessed = summaryData.reduce((s, r) => s + r.processed_amount, 0);
      const totalUnprocessed = summaryData.reduce((s, r) => s + r.unprocessed_amount, 0);
      const totalPhonePeCollection = summaryData.reduce((s, r) => s + r.phonepe_collection, 0);

      setSummaryTotals({
        total: totalTotal,
        processed: totalProcessed,
        unprocessed: totalUnprocessed,
        phonepe_collection: totalPhonePeCollection,
      });
    }
  }, [summaryData]);


  const handleOpen = () => {
    setIsUploadOpen(true)
    setFileList([])
    setUploadLoading(false)
  }
  
  const handleClose = () => {
    setIsUploadOpen(false)
    setFileList([])
    setUploadLoading(false)
  }

  const handleUpload = async () => {
    setUploadLoading(true)
    if (fileList.length === 0) {
      message.warning("Please select a file before uploading!");
      return;
    }

    const file = fileList[0].originFileObj;
    try {
      const data = await uploadFileToAPI(file);
      message.success(data.message || "File uploaded successfully!");
      handleClose()
    } catch (error) {
      message.error(error.message || "Something went wrong!");
    } finally {
      setUploadLoading(false);
      get_phonepe_summary()
    }
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList.slice(-1))
  };

  const uploadFileToAPI = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const url = `${getLocationOrigin()}/finance/upload_phonepe_transactions_from_excel/`;
    const options = {
      method: "POST",
      body: formData,
    };

    const response = await fetch(url, options);
    if (!response.ok) throw new Error("Upload failed");
    return response.json();
  };

  const get_phonepe_summary = () => {
    setSummaryLoader(true)

    var month = selectedMonth.format('MM')
    var year = selectedMonth.format('YYYY')

    getData(`/finance/get_phonepe_venue_wise_summary/?month=${month}&year=${year}`)
    .then(response =>{
      setSummaryData(response.result)
      setSummaryLoader(false)
    })
    .catch(error => {
      setSummaryLoader(false)
      alert(error.message);
    });
  }

  const columns = [
    {
      title: "Venue",
      dataIndex: "venue_name",
    },
    // {
    //   title: "Store Name",
    //   dataIndex: "store_names",
    //   render: (value) => {
    //     if (!value) return "-";

    //     return value.split(",").map((store, index) => (
    //       <div key={index}>{store.trim()}</div>
    //     ));
    //   },
    // },
    {
      title: "PhonePe Entries",
      dataIndex: "total_amount",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Processed",
      dataIndex: "processed_amount",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Unprocessed",
      dataIndex: "unprocessed_amount",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "PhonePe Collection",
      dataIndex: "phonepe_collection",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "",
      width: 20,
    },
    
  ];

  return (
    <div style={{ padding: 20 }}>
      <PageHeader>
        <PageTitle>PhonePe Summary</PageTitle>

        <RightActions>
          <Button 
            type="primary" 
            icon={<UploadOutlined />} 
            style={{ borderRadius: 8 , color: 'white', backgroundColor: '#1565c0', borderColor:'#1565c0'}}
            onClick={handleOpen}
          >
            Upload PhonePe Transaction List
          </Button>
          <Modal
            title="Upload PhonePe Payment List"
            open={isUploadOpen}
            onCancel={handleClose}
            confirmLoading={uploadLoading}
            footer={[
              <Button key="cancel" onClick={handleClose}>
                Cancel
              </Button>,
              <Button
                key="upload"
                type="primary"
                onClick={handleUpload}
                loading={uploadLoading}
                disabled={!fileList.length}
              >
                Upload
              </Button>,
            ]}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <Upload
                accept=".xlsx"
                fileList={fileList}
                onChange={handleFileChange}
                beforeUpload={() => false} 
              >
                <Button icon={<UploadOutlined />}>Select .xlsx File</Button>
              </Upload>
            </Space>
          </Modal>

          <MonthPicker
            value={selectedMonth}
            onChange={(value) => setSelectedMonth(value)}
            format="MMMM YYYY"
            placeholder="Select month"
            style={{ width: 200 }}
          />

        </RightActions>
      </PageHeader>

      <div style={{ display: "flex", gap: 15, marginBottom: 20 }}>

        <SmallStatBox>
          <BarChartOutlined style={{ flex: 1,fontSize: 35, color: "#1890ff" }} />
          <StatText>
            <StatTitle>Phonepe Entries</StatTitle>
            <StatValue>{Math.round(summaryTotals.total).toLocaleString("en-IN")}</StatValue>
          </StatText>
        </SmallStatBox>

        <SmallStatBox>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{flex: 1, fontSize: 35 }} />
          <StatText>
            <StatTitle>Processed</StatTitle>
            <StatValue>{Math.round(summaryTotals.processed).toLocaleString("en-IN")}</StatValue>
          </StatText>
        </SmallStatBox>

        <SmallStatBox>
          <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{flex: 1, fontSize: 35 }} />
          <StatText>
            <StatTitle>Unprocessed</StatTitle>
            <StatValue>{Math.round(summaryTotals.unprocessed).toLocaleString("en-IN")}</StatValue>
          </StatText>
        </SmallStatBox>

        <SmallStatBox>
          <CheckCircleTwoTone twoToneColor="#1565c0" style={{flex: 1, fontSize: 35 }} />
          <StatText>
            <StatTitle>PhonePe Collection</StatTitle>
            <StatValue>{Math.round(summaryTotals.phonepe_collection).toLocaleString("en-IN")}</StatValue>
          </StatText>
        </SmallStatBox>

      </div>

      <div style={{ marginBottom: 10, fontSize: 12, color: "#666" }}>
        Note: <Typography.Text strong>PhonePe Entries, Processed and Unprocessed</Typography.Text> values are derived from the PhonePe XLSX upload data.
        
        <Typography.Text strong> PhonePe Collection</Typography.Text> reflects the actual amount collected in the system through the PhonePe payment mode.
      </div>

      <div className="summary-table-wrapper">
        <Table 
          columns={columns} 
          dataSource={summaryData} 
          pagination={false}
          bordered={false}
          loading={summaryLoader}
          size="middle"summary={() => {
            const totalTotal = summaryData.reduce((s, r) => s + r.total_amount, 0);
            const totalProcessed = summaryData.reduce((s, r) => s + r.processed_amount, 0);
            const totalUnprocessed = summaryData.reduce((s, r) => s + r.unprocessed_amount, 0);
            const totalPhonePeCollection = summaryData.reduce((s, r) => s + r.phonepe_collection, 0);

            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}><b>Total</b></Table.Summary.Cell>

                <Table.Summary.Cell index={2} align="right">
                  <b>{Math.round(totalTotal).toLocaleString("en-IN")}</b>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={3} align="right" style={{ color: "#389e0d" }}>
                  <b>{Math.round(totalProcessed).toLocaleString("en-IN")}</b>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={4} align="right" style={{ color: "#cf1322" }}>
                  <b>{Math.round(totalUnprocessed).toLocaleString("en-IN")}</b>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={5} align="right" style={{ color: "#1565c0" }}>
                  <b>{Math.round(totalPhonePeCollection).toLocaleString("en-IN")}</b>
                </Table.Summary.Cell>

              </Table.Summary.Row>
            );}}
        />
      </div>

    </div>
  );
}

export default PhonePeSummary;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
`;

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PageTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1565c0;
`;

export const SmallStatBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  width: 25%;
`;

export const StatText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 4;
`;

export const StatTitle = styled.div`
  font-size: 12px;
  color: #666;
`;

export const StatValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #052e67;
`;
